import React, {memo, useRef} from "react";
import {Form, FormControl, Spinner} from "react-bootstrap";
import axios from "axios";
import {BASE_URL, MORE_PRODUCTS_DETAILS_POST, PRODUCTS_SEARCH_POST, PRODUCTS_SEARCH_RESULT_POST, PUBLIC_URL_SERVER} from "../../../../apis";
import qs from "querystring";
import {useDispatch, useSelector} from "react-redux";
import {useHistory, useRouteMatch} from "react-router-dom";
import {
    actionChangeLoaderInputsSearch, actionChangeTextInputsSearch, ChangeListPageResultSearch, ChangeListResultSearch
} from "../../../../redux/actions/partals/search";
import {
    actionChangeLoaderModalProduct, handelChangeDataSingleProduct,
    handelChangeSelectGradeModalProduct, handelOpenModalProduct
} from "../../../../redux/actions/modals/ModalProduct";
import swal from 'sweetalert';
import Swal from 'sweetalert2';
import {handelOpenModalLoginAndRegister} from "../../../../redux/actions/modals/modalLoginAndRegister";
import {FaSearch, FaTimesCircle} from "react-icons/all";

const Search = () => {
    const match = useRouteMatch();
    const store = useSelector(state => state.stores.list_stores.find(storeItem => storeItem.id === match.params.store));
    const {result, text, loaderSearch} = useSelector(state => state.search);
    const {carts} = useSelector(state => state.shoppingCart);
    const {token} = useSelector(state => state.user);
    const refListSearch = React.createRef();
    const dispatch = useDispatch();
    const history = useHistory();

    const cancelSearch = useRef(null);

    const handleChangeInputSearch = (event) => {
        const {value} = event.target;

        dispatch(actionChangeTextInputsSearch(value));

        const LIST_SEARCH = refListSearch.current;

        if (value.length >= 2) {
            callApiSearch(LIST_SEARCH, value);
        }

    };

    const callApiSearch = async (LIST_SEARCH, value) => {
        try {
            dispatch(actionChangeLoaderInputsSearch(true));

            if (cancelSearch.current) {
                cancelSearch.current('search canceled');
            }

            const response = await axios.post(BASE_URL + PRODUCTS_SEARCH_POST,
                qs.stringify({
                    store: store.id,
                    search_text: value
                }), {
                    cancelToken: new axios.CancelToken(cancel => cancelSearch.current = cancel)
                });


            const {data} = response;

            if (data.status === 'ok') {
                if (data.products.length > 0) {
                    LIST_SEARCH.classList.add('show-list-auto-complete');
                    dispatch(ChangeListResultSearch(data.products));
                } else {
                    LIST_SEARCH.setAttribute("class", "list-auto-autocomplete");
                }
            } else {
                LIST_SEARCH.setAttribute("class", "list-auto-autocomplete");
            }
            if (data)
                dispatch(actionChangeLoaderInputsSearch(false));

        } catch (e) {
            console.log(e);
        }
    }

    const handleOnBlurSearch = () => {
        const LIST_SEARCH = refListSearch.current;
        setTimeout(() => {
            LIST_SEARCH.setAttribute("class", "list-auto-autocomplete");
        }, 500);
    };
    const handleOnFocusSearch = (event) => {
        handleChangeInputSearch(event);
    };

    const apiGetDataSingleProduct = (id) => {
        dispatch(handelOpenModalProduct());
        dispatch(actionChangeLoaderModalProduct(true));
        axios({
            method: 'post',
            url: BASE_URL + MORE_PRODUCTS_DETAILS_POST,
            data: qs.stringify({
                product: id
            }),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        }).then((response) => {
            if (response.data.status === "ok") {
                dispatch(handelChangeDataSingleProduct(response.data.product, response.data.similar, response.data.options));
                if (carts.length > 0)
                    for (const cart in carts) {
                        if (carts[cart].grades[0].gradeId === response.data.product.grades[0].gradeId) {
                            dispatch(handelChangeSelectGradeModalProduct({
                                ...response.data.product.grades[0],
                                default: carts[cart].w_numbers
                            }, carts[cart].optionSelect));
                            break;
                        } else {
                            dispatch(handelChangeSelectGradeModalProduct(response.data.product.grades[0]));
                        }
                    }
                else
                    dispatch(handelChangeSelectGradeModalProduct(response.data.product.grades[0]));

                if (response.data.product.desc_show){
                    const btnOkSingle = Swal.mixin({
                        customClass: {
                            confirmButton: 'base-btn-green-border btn btn-success',
                        },
                        buttonsStyling: false
                    });
                    btnOkSingle.fire({
                        text: response.data.product.desc_show,
                        imageUrl: PUBLIC_URL_SERVER + '/icons/fm_logo_ofoghi_new.png',
                        imageHeight: 45,
                        imageAlt: 'فروت مروت',
                        confirmButtonText: "تایید",
                    });
                }
            }
            dispatch(actionChangeLoaderModalProduct(false));
        });
    };

    const validateLogin = (id) => {
        if (token) {
            apiGetDataSingleProduct(id);
        } else {
            dispatch(handelOpenModalLoginAndRegister());
        }
    };

    const handleSubmitFormSearch = async (event) => {
        event.preventDefault();
        const url = BASE_URL + PRODUCTS_SEARCH_RESULT_POST;
        const data = qs.stringify({store: store.id, search_text: text});
        const config = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
            }
        };
        try {
            const response = await axios.post(url, data, config);
            const {data:apiData} = response;
            if(apiData.status === 'ok'){
                if (response.data.products.length > 0) {
                    dispatch(ChangeListPageResultSearch(response.data.products));
                    history.push({pathname: `/stores/${match.params.store}/search`, search: `?text=${text}`});
                } else {
                    // history.push({pathname: `${match.url}`});
                    swal({
                        title: "جستوجو",
                        text: 'موردی یافت نشد',
                        buttons: {
                            cancel: "تایید",
                        },
                        icon: "error",
                    });
                }
            }
        }catch (e){
            swal({title: "اختلال در سیستم", text: 'لطفا مجددا تلاش کنید', buttons: {cancel: "تایید",}, icon: "error"});
            console.error('error : ',e.response);
        }
    };

    const removeTextSearch = () => {
        dispatch(actionChangeTextInputsSearch(''));
    }
    return (
        <div className={'mb-2'}>
            <Form onSubmit={handleSubmitFormSearch} className={'base-form-search'}>
                <div className="input-group-cm-search">
                    <FormControl id="inlineFormInputGroupUsername2"
                                 className={'cm-input-search'}
                                 onChange={handleChangeInputSearch} autoComplete={"off"}
                                 onFocus={handleOnFocusSearch}
                                 onBlur={handleOnBlurSearch}
                                 value={text}
                                 placeholder="نام محصول موردنظر خود را وارد کنید..."/>
                    <div className={'box-btns-search'}>
                        <div className='box-loader-input-search'>
                            {loaderSearch
                                ? <Spinner className='spinner-input-search' animation={"border"} variant={'secondary'}/>
                                : (text.length > 0) ? <FaTimesCircle onClick={removeTextSearch}
                                    className='icon-remove-text-input-search text-secondary' size={"30px"}/> : null}
                        </div>
                        <div onClick={handleSubmitFormSearch}
                             className='btn btn-success base-btn-green btn-search-icon'>
                            <FaSearch/>
                        </div>
                    </div>
                </div>
                <div className={'list-auto-autocomplete'} ref={refListSearch}>
                    <ul>
                        {result.map((item, index) => {
                            return <li key={index} onClick={() => validateLogin(item.id)}>{item.title}</li>;
                        })}
                    </ul>
                </div>
            </Form>
        </div>
    );
};

export default memo(Search);
